import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'
import FormGroup from '../components/FormGroup.vue'

Vue.use(VuelidateErrorExtractor, {
  i18n: 'validationMessages',
  i18nAttributes: {
    __default: 'labels'
  }
})

Vue.component('FormWrapper', templates.FormWrapper)
Vue.component('FormGroup', FormGroup)

Vue.use(Vuelidate)
